import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { FINANCIALANALYSYS_FINANCIAL_LIST } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetFinancialAnalysisFinancialList extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = [];

  url = FINANCIALANALYSYS_FINANCIAL_LIST;

  constructor(applicantId, finAnalysisId) {
    super();
    const paramList = [applicantId, finAnalysisId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
